import { useState } from "react";
import "./stats.less";
import DataOverview from "../components/DataOverview";
import TotalLiquidityChart from "../components/TotalLiquidityChart";
import DailyTxCountChart from "../components/DailyTxCountChart";
import DailyTxVolumeChart from "../components/DailyTxVolumeChart";
import reloadPng from "../images/reload.png";
import DailyUniqueUserChart from "../components/DailyUniqueUserChart";

const Stats = () => {
  const [reloadFlag, toggleReloadFlag] = useState(false);

  const reloadStats = () => {
    toggleReloadFlag(!reloadFlag);
  };

  return (
    <div className="stats">
      <div className="stats-title">
        <div className="stats-title-text">Overall Stats</div>
        <div className="stats-title-reload" onClick={reloadStats}>
          <img src={reloadPng} alt="reload png" />
        </div>
      </div>
      <div className="stats-content">
        <DataOverview reloadFlag={reloadFlag} />
        <div className="stats-content-charts">
          <TotalLiquidityChart reloadFlag={reloadFlag} />
          <DailyTxCountChart reloadFlag={reloadFlag} />
          <DailyTxVolumeChart reloadFlag={reloadFlag} />
          <DailyUniqueUserChart reloadFlag={reloadFlag} />
        </div>
      </div>
    </div>
  );
};

export default Stats;
